import {
  Users, Wallet, Calendar, MessageCircle, Building2, DollarSign, BarChart3,
  Crown, Palette, ClipboardList, Utensils, CalendarDays, Phone,
  Wrench, ShoppingCart, Sparkles, Contact, ListTodo, Package, Truck,
  CreditCard, Globe, Calculator, ShoppingBag, Eye,
} from "lucide-react";
import type { QuickAction } from "@/lib/palette-config";

const iconMap: Record<string, any> = {
  Users, Wallet, Calendar, MessageCircle, Building2, DollarSign, BarChart3,
  Crown, Palette, ClipboardList, Utensils, CalendarDays, Phone,
  Wrench, ShoppingCart, Sparkles, Contact, ListTodo, Package, Truck,
  CreditCard, Globe, Calculator, ShoppingBag, Eye,
};

interface Props {
  quickActions: QuickAction[];
  onNavigate: (path: string) => void;
}

export default function PaletteQuickActions({ quickActions, onNavigate }: Props) {
  if (quickActions.length === 0) return null;

  return (
    <div className="px-3 py-2">
      <div className="uppercase text-[10px] tracking-wider text-white/40 px-1 mb-2 font-medium">
        Quick Actions
      </div>
      <div className="grid grid-cols-3 gap-2">
        {quickActions.slice(0, 9).map((action) => {
          const Icon = iconMap[action.icon] || Calendar;
          return (
            <button
              key={action.path + action.label}
              onClick={() => onNavigate(action.path)}
              className="flex flex-col items-center gap-2 p-3 rounded-xl bg-white/[0.03] border border-white/[0.06] hover:border-[#B8860B]/30 hover:bg-[#B8860B]/5 transition-all cursor-pointer group"
            >
              <Icon className="w-5 h-5 text-white/40 group-hover:text-[#B8860B] transition-colors" />
              <span className="text-[11px] text-white/50 group-hover:text-white/80 transition-colors text-center leading-tight">
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
